import React from 'react'
import Helmet from 'react-helmet'
import mediumZoom from 'medium-zoom'
import { Form, Input, Button, Alert } from 'antd'

import axios from 'axios'

import Layout from '../components/layout'

// import pic01 from '../assets/images/pic01.jpg'
// import pic02 from '../assets/images/pic02.jpg'
// import pic03 from '../assets/images/pic03.jpg'
// import pic04 from '../assets/images/pic04.jpg'
import conceptPic from '../assets/images/concept.png'

const REQUEST_ERROR =
  'We have troubles submitting your request. Please try again.'

class Homepage extends React.Component {
  clearGlobalErrors = () => {
    this.setState({ showError: false, error: '' })
  }

  state = {
    showError: false,
    isSent: false,
    error: '',
  }

  handleSubmit = e => {
    e.preventDefault()
    this.clearGlobalErrors()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true })
        axios
          .post(`${process.env.DEPSI_API_URL}/newsletter/signup`, { ...values })
          .then(resp => {
            const { success } = resp.data
            if (success) {
              this.setState({ isSent: true })
              this.props.form.resetFields()

              setTimeout(() => {
                this.setState({ isSent: false })
              }, 3000)
            } else {
              this.setState({
                showError: true,
              })
            }
            this.setState({ loading: false })
          })
          .catch(e =>
            this.setState({
              showError: true,
              loading: false,
            })
          )
      }
    })
  }

  componentDidMount() {
    mediumZoom('[data-zoomable]')
  }

  render() {
    const siteTitle = 'DEPSI'

    const { getFieldDecorator } = this.props.form
    const { isSent, showError, error } = this.state

    return (
      <Layout>
        <Helmet title={siteTitle} />

        <section id="one" className="main style1">
          <div className="grid-wrapper">
            <div className="col-6">
              <header className="major">
                <h2>The Internet as a database</h2>
              </header>
              <p>
                The Internet is the largest database in the world, but also is
                the most fragmented one. DEPSI makes it easy to access accurate
                data from either a single website or the entire Internet.
              </p>
            </div>
            <div className="col-6">
              <span className="image fit">
                <img
                  src={conceptPic}
                  alt="Concept map"
                  width="350"
                  data-zoomable
                />
              </span>
            </div>
          </div>
        </section>

        <section id="three" className="main style2 special">
          <div className="grid-wrapper">
            <div className="col-12">
              <header className="major">
                <h2>Our features</h2>
              </header>
            </div>

            <div className="col-4">
              <h3>Zero configuration</h3>
              <p>Choose predefined data sources with customized data fields.</p>
            </div>
            <div className="col-4">
              <h3>Structured data</h3>
              <p>
                Retrieve data from the Internet in the meaningful way that is
                easy to understand and reason about. <br />
              </p>
            </div>
            <div className="col-4">
              <h3>Fully-managed service</h3>
              <p>
                We take care of the end-to-end data pipeline -- from building
                and maintaining extraction to cleaning, normalizing and
                maintaining the data quality. <br />
              </p>
            </div>

            <div className="col-4">
              <h3>API ready</h3>
              <p>
                Bring data into your app and control what data to get, set and
                display with powerful GraphQL API.
              </p>
            </div>
            <div className="col-4">
              <h3>Dedicated support</h3>
              <p>
                We work with strong SLAs, provide prompt support and deliver
                more than we promise.
              </p>
            </div>
            <div className="col-4">
              <h3>Customization</h3>
              <p>
                Didn't find a data set for your bussiness? Not a problem, we
                will help you to build a custom one that satisfies your unique
                bussiness needs.
              </p>
            </div>
          </div>
        </section>

        {/* <section id="four" className="main style1 special">
          <div className="container">
            <header className="major">
              <h2>Ready to go?</h2>
            </header>
            <ul className="actions uniform">
              <li>
                <a href="https://depsi.co/demo" className="button">
                  Demo
                </a>
              </li>
              <li>
                <a
                  href="https://app.depsi.co/register"
                  className="button special"
                >
                  Sign Up
                </a>
              </li>
            </ul>
          </div>
        </section> */}

        <section id="five" className="main style1 special">
          <div className="grid-wrapper">
            <div className="col-12">
              <header className="major">
                <h2>Stay in touch</h2>
              </header>
              {isSent ? (
                <section>Thank you for subscribing! 🚀</section>
              ) : (
                <section>
                  Join our community of indie builders. <br /> Subscribe to our
                  newsletter to get the latest news and updates from Depsi.co
                </section>
              )}
            </div>
            <div className="col-3"></div>
            <div className="col-6">
              <Form
                onSubmit={this.handleSubmit}
                className={'login-form'}
                onFocus={this.clearGlobalErrors}
              >
                {showError && (
                  <Form.Item>
                    <Alert message={error} type="error" />
                  </Form.Item>
                )}
                <Form.Item style={{ margin: '20px 0' }}>
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter your name',
                      },
                    ],
                  })(<Input placeholder="Your name" />)}
                </Form.Item>

                {showError && (
                  <Form.Item>
                    <Alert message={error} type="error" />
                  </Form.Item>
                )}
                <Form.Item>
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail',
                      },
                      {
                        required: true,
                        message: 'Please input your E-mail',
                      },
                    ],
                  })(<Input placeholder="Your email" />)}
                </Form.Item>
                <Form.Item>
                  <Button
                    style={{ width: '100%', margin: '20px 0', color: '#fff' }}
                    type="primary"
                    htmlType="submit"
                    className="button special"
                  >
                    {this.state.loading
                      ? 'Loading...'
                      : 'Sign up for our newsletter'}
                  </Button>
                </Form.Item>

                {showError && (
                  <Form.Item>
                    <Alert message={REQUEST_ERROR} type="error" />
                  </Form.Item>
                )}

                <section style={{ marginTop: '20px' }}>
                  This is a manually curated newsletter. We won't send you spam.
                  You can unsubscribe at any time. We know that your time is
                  valuable.
                </section>
              </Form>
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}

const HomepageWithForm = Form.create({
  name: 'newsletter',
})(Homepage)

export default HomepageWithForm
